import styled from "styled-components";
import { Link } from "react-router-dom";
import { device } from "../styles/Responsive.style";

const WhyAttri = () => {
  return (
    <PageWrapper>
        <Top>
            <h3>Why attriDNA?</h3>
            <section>
                <div>
                    <h4>1. Attribute Complexity</h4>
                    <p>
                    Unlike many competitors, attriDNA focuses on assessing complex,
                    multi-dimensional attributes such as emotional intelligence,
                    adaptability, and resilience, which go beyond simple cognitive
                    skills or technical ability. This complexity allows for a more
                    holistic view of an individual’s fit for digital roles.
                    </p>
                </div>
                <div>
                    <h4>2. Tailored Role Specific Guidance</h4>
                    <p>
                    attriDNA provides customised role alignment, offering tailored
                    pathways into specific digital careers, such as cybersecurity,
                    software development, and project management. This is unlike
                    broader, generic career guidance tools which may not align closely
                    with industry specific needs.
                    </p>
                </div>
                <div>
                    <h4>3. Attribute Driven Decision Making</h4>
                    <p>
                    Rather than just focusing on aptitude, attriDNA emphasises
                    behavioural and emotional attributes that are increasingly
                    critical for success in digital roles. This allows organisations
                    to find candidates who not only have the technical skills but also
                    possess the attributes to thrive in dynamic and evolving digital
                    environments.
                    </p>
                </div>
                <div>
                    <h4>4. Integration of Soft Skills</h4>
                    <p>
                    attriDNA integrates soft skills assessments into its framework,
                    helping organisations identify candidates who are strong in
                    teamwork, communication, and leadership — essential skills for
                    digital roles that often require collaboration and innovation.
                    </p>
                </div>
                <div>
                    <h4>5. Technology and AI Integration</h4>
                    <p>
                    By leveraging AI-driven tools to refine attribute-based matching,
                    attriDNA offers precise recommendations on career pathways and
                    upskilling options, making it highly relevant for digital and
                    technology driven industries.
                    </p>
                </div>
                <div>
                    <h4>6. Flexibility for Non-Technical Candidates</h4>
                    <p>
                    attriDNA’s model is designed to assess candidates with limited
                    technical experience, guiding them into suitable digital roles
                    based on their inherent attributes, providing a pathway for
                    individuals to transition into tech even from non-technical
                    backgrounds.
                    </p>
                </div>
            </section>
        </Top>
    
        <Middle>
            <h3>The Data</h3>
            <p>attriDNA turns results into <b>powerful visual insights</b>. Your unique attribute profile is plotted on an interactive <b>radar chart</b>, giving you a clear picture of where your natural strengths lie — and which areas offer the greatest opportunity for growth.</p>
            <p>Compare your results against <b>industry or population averages</b> to understand how your attributes stack up against others in the digital economy. These insights pinpoint what makes you stand out, highlight areas for development, and guide your next steps — whether that’s building confidence in your current role, preparing for progression, or exploring new career paths.</p>
            <p>For employers, aggregated results reveal <b>team-level trends and gaps</b>, allowing you to identify hidden talent, build balanced teams, and make data-led decisions about recruitment and upskilling.</p>
        </Middle>
 
    </PageWrapper>
  );
};

export default WhyAttri;

const PageWrapper = styled.main`
  width: 100%;
  max-width: 1500px;
  padding: 0 50px;
  box-sizing: border-box;
  margin: 0 auto;
`;

const Top = styled.div`
    margin-top: 50px;

    h3 {
        font-size: var(--font-large);
        margin: 0;
        text-align: center;
    }
    p {
        font-size: var(--font-small);
        color: var(--text-main);
    }

    h3.white {
        font-size: var(--font-large);
        margin: 0;
        color: white;

        b {
            color: var(--accent);
        }
    }

    & section {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin: 15px 0;
        border-radius: 10px;
        background: linear-gradient(45deg, var(--accent), var(--orange));
        padding: 10px;
    }

    & section div {
        width: calc(50% - 5px);
        box-sizing: border-box;
        padding: 0px 18px 18px;
        background: var(--bg-main-light);
        border-radius: 10px;
    }

    & section h4 {
        margin-bottom: 10px;
        font-size: var(--font-medium);
    }

    @media ${device.small} {
        & {
            padding: 40px 0;
        }
        h3 {
            text-align: center;
        }
        p {
            text-align: center;
        }

        & section div {
            width: 100%;
            margin-bottom: 0px;
        }
    }
`;

const Middle = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 50px 0;

    h3 {
        font-size: var(--font-large);
        margin: 0;
        color: white;
    }

    p {
        text-align: center;
    }
`;